// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"error-message_errorMessage__fRQ-d","button":"error-message_button__bTS2q"};